import { defineStore } from 'pinia'

export const useStateCityStore = defineStore('stateCity', {
  state: () => ({
    selectedState: null,
    selectedCity: null,
    selectedStateName: null,
    searchTerm: null
  }),

  actions: {
    setState(state, stateName) {
      this.selectedState = state
      this.selectedStateName = stateName
    },
    setCity(city) {
      this.selectedCity = city
    },
    setSearchTerm(term) {
      this.searchTerm = term
    },
    reset() {
      this.selectedState = null
      this.selectedCity = null
      this.selectedStateName = null
      this.searchTerm = null
    }
  },

  getters: {
    getState: (state) => state.selectedState,
    getCity: (state) => state.selectedCity,
    getStateName: (state) => state.selectedStateName,
    getSearchTerm: (state) => state.searchTerm,
    hasStateAndCity: (state) => state.selectedState && state.selectedCity
  }
}) 